module.exports = __webpack_public_path__ + "static/media/no_minute_3.9037ab97.jpg";